import { TOKEN_CLIENT_LOCAL_STORAGE_NAME } from '../constants/constants';

const getAccessToken = () => {
  const { accessToken } = JSON.parse(localStorage.getItem(TOKEN_CLIENT_LOCAL_STORAGE_NAME)) || {};
  return accessToken;
};

export default getAccessToken;
